import React from "react";

import LandingHero from "./landing_hero";
import ProductOverview from "./product_overview";
import KeyFeatures from "./features";
import BannerFullWidth from "./feature_banner_full_width";
import VideoTimelapseFeature from "./video_timelapse_feature";
import QuotationBannerFullWidth from "./quotation_banner_full_width";
import FaqSection from "./faq_section";
import ReviewBanner from "./reviews";
import Footer from "./footer";
import ContactForm from "./form_section";

export default function Landing() {

    return (
        <React.Fragment>
            <LandingHero/>
            <ProductOverview/>
            <BannerFullWidth/>
            <VideoTimelapseFeature/>
            <QuotationBannerFullWidth/>
            <FaqSection/>
            <ContactForm/>
            <ReviewBanner/>
            <Footer/>
        </React.Fragment>
    )
}